<?php

Namespace Model\Logout;

class PageModel extends \Model\Base
{

    public $returned_data;

    public function getPage()
    {
        $page = array();
        $page['title'] = 'Logout of your Video Interviews account';
        $page['heading'] = 'Thanks for using Video Interviews!';
        \ISOPHP\js_core::$console->log('Logout Mod', $page);
        return $page;
    }


    public function performLogout()
    {
        $vars['control'] = 'Logout';
        $vars['action'] = 'now';
        $registry = \ISOPHP\core::$registry;
        $logged = $registry->getValue('user_logged');
        \ISOPHP\js_core::$console->log('registry is ', $logged);
        $registry::setValue('user_logged', null);
        $logged = $registry->getValue('user_logged');
        \ISOPHP\js_core::$console->log('apply logout done, now navigate', $logged);
        $navigate = new \Model\Navigate();
        $navigate->route('LandingPage', 'show', array(), '/');
        $result = true;
        return $result;
    }

}


// WEBPACK FOOTER //
// app/Logout/Model/LogoutPageModel.php